import { useEffect, useState } from 'react'

import { useMediaSession as useMediaSessionGeneric } from '@/hooks/useMediaSession'
import type { StoredExternalMusic } from '@/lib/db'

type UseMediaSessionProps = {
  music: StoredExternalMusic | null
  audioRef: React.RefObject<HTMLAudioElement | null>
  onPreviousTrack?: () => void
  onNextTrack?: () => void
}

/**
 * カスタム音楽用のMediaSessionラッパー
 * StoredExternalMusic の thumbnailBlob から ObjectURL を生成し、汎用フックに渡す
 */
export const useMediaSession = ({ music, audioRef, onPreviousTrack, onNextTrack }: UseMediaSessionProps) => {
  const [artworkUrl, setArtworkUrl] = useState<string | undefined>()

  // アートワークURLの生成・解放
  useEffect(() => {
    let objectUrl: string | undefined

    if (music?.thumbnailBlob) {
      objectUrl = URL.createObjectURL(music.thumbnailBlob)
      setArtworkUrl(objectUrl)
    } else {
      setArtworkUrl(undefined)
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [music?.thumbnailBlob, music?.id])

  useMediaSessionGeneric({
    title: music?.title ?? null,
    artist: music?.artist ?? undefined,
    album: 'カスタム音楽',
    artworkUrl,
    audioRef,
    onPreviousTrack,
    onNextTrack,
  })
}
